let karteId = '';

/**
 * main_dbのユーザーIDを返す。
 * callGetUserIdApiをラップしている。
 * 呼び出したテンプレート内で「user-info」セクションが読み込まれていないと使用できない。
 * @returns {string} main_dbのユーザーID
 */
async function getUserId() {
  const element = document.getElementById('shopify-id');
  if (element === null) {
    return '';
  }
  const response = await callGetUserIdApi(element.value);
  return response.user_id;
}

/**
 * ShopifyのユーザーIDをカルテのユーザーIDに変換するAPIを呼び出す
 * @param {string} shopifyId
 * @returns {object} ユーザーIDオブジェクト
 */
async function callGetUserIdApi(shopifyId) {
  if (karteId) {
    return karteId;
  }
  try {
    const response = await fetch(`${externals.ebisu_api_endpoint}/user_id?shopify_id=${shopifyId}`);
    if (!response.ok) {
      const data = await response.json();
      console.error(data);
      throw new Error(`APIエラー。ステータスコード: ${response.status}`);
    }
    const data = await response.json();
    karteId = data;
    return data;
  } catch (error) {
    console.error('ユーザーID取得APIの通信に失敗しました。');
    throw error;
  }
}

/**
 * ログ登録一覧取得APIを呼び出す
 * @param {string} userId
 * @returns {object} ログ登録一覧情報オブジェクト
 */
async function callUserWineRatesApi(userId) {
  if (userId === '') {
    return { item_list: [] };
  }
  try {
    const response = await fetch(
      `${externals.ebisu_api_endpoint}/user_wine_rates?user_id=${userId}`,
    );
    if (!response.ok) {
      const data = await response.json();
      console.error(data);
      throw new Error(`APIエラー。ステータスコード: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('アルバム一覧取得APIの通信に失敗しました。');
    throw error;
  }
}

/**
 * スタッフレビュー取得APIを呼び出す
 * @param {string} requestParams
 * @returns {object} スタッフレビューオブジェクト
 */
async function callStaffReviewApi(requestParams) {
  try {
    const response = await fetch(`${externals.ebisu_api_endpoint}/staff/review?${requestParams}`);
    if (!response.ok) {
      const data = await response.json();
      console.error(data);
      throw new Error(`APIエラー。ステータスコード: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('スタッフレビュー取得APIの通信に失敗しました。');
    throw error;
  }
}

/**
 * 国旗画像のURLを取得する
 * @param {string} countryName 国名
 * @returns {string} 画像のURL
 */
function getNationalFlagImage(countryName) {
  const countryNameMap = {
    アゼルバイジャン: 'azerbaijan',
    アメリカ: 'usa',
    アルジェリア: 'algeria',
    アルゼンチン: 'argentina',
    イギリス: 'uk',
    イタリア: 'italy',
    インド: 'india',
    ウクライナ: 'ukraine',
    ウルグアイ: 'uruguay',
    オーストラリア: 'australia',
    オーストリア: 'austria',
    カナダ: 'canada',
    キプロス: 'cyprus',
    ギリシャ: 'greece',
    ジョージア: 'georgia',
    スイス: 'swiss',
    スウェーデン: 'sweden',
    スペイン: 'spain',
    スロバキア: 'slovakia',
    スロベニア: 'slovenia',
    チェコ: 'czech',
    チュニジア: 'tunisia',
    チリ: 'chile',
    ドイツ: 'germany',
    ニュージーランド: 'newzea',
    ハンガリー: 'hungary',
    フランス: 'france',
    ブラジル: 'brazil',
    ブルガリア: 'bulgaria',
    ベルギー: 'belgium',
    ペルー: 'peru',
    ポルトガル: 'portugal',
    ポーランド: 'poland',
    モロッコ: 'morocco',
    ルクセンブルク: 'luxembourg',
    ルーマニア: 'romania',
    レバノン: 'lebanon',
    ロシア: 'russia',
    中国: 'china',
    南アフリカ: 'southafrica',
    日本: 'japan',
  };
  return `https://${externals.karte_domain}/images/common/icon_flag_${countryNameMap[countryName]}.svg`;
}

/**
 * taste_class_cdをアルファベットと数字に分離する
 * @param {string} tasteClassCd
 * @returns {RegExpExecArray} RegExp.execの戻り値
 */
function splitTasteClassCd(tasteClassCd) {
  const regex = /([A-Z]+)(\d+)/;
  const splittedTasteClassCd = regex.exec(tasteClassCd);
  return splittedTasteClassCd;
}

/**
 * wineListから、itemListToExcludeが持つitem_cdのワインを除外する
 * @param {Array} wineList 元となるワインリスト
 * @param {Array} itemListToExclude 除外したいワインのitem_cdのリスト
 * @returns {Array} 元となるワインのリストから特定のワインが除外されたワインのリスト
 */
function excludeWinesBasedOnItemCd(wineList, itemListToExclude) {
  if (itemListToExclude.length === 0) {
    return wineList;
  }
  return wineList.filter((wine) => {
    return !itemListToExclude.includes(wine.item_cd);
  });
}

function checkUrlParameter(param) {
  // URLのパラメーターを取得
  const urlSearchParams = new URLSearchParams(window.location.search);
  const webmenu = urlSearchParams.get(param);

  return webmenu;
}

function hideFeatureByClass(features) {
  // クラスベースの項目非表示
  for (var i = 0; i < features.length; i++) {
    const elements = document.getElementsByClassName(features[i]);

    for (var j = 0; j < elements.length; j++) {
      elements[j].style.display = 'none';
    }
  }
}

// テストの時だけ実行
if (typeof module !== 'undefined') {
  module.exports = {
    getUserId,
    excludeWinesBasedOnItemCd,
  };
}
